import { AuthUserPermission, useOrganizationList, usePermissions } from '@cibo/profile'
import { ADMIN_ROUTES } from 'navigation/types'
import { Forbidden } from 'pages/Forbidden'
import { Navigate, generatePath } from 'react-router-dom'

export const AdminRoot = () => {
  const { can } = usePermissions()
  const organizations = useOrganizationList()

  if (can({ useAny: [AuthUserPermission.PROGRAMS_EDIT, AuthUserPermission.MANAGE_PROGRAMS] })) {
    return <Navigate to={ADMIN_ROUTES.PROGRAM_LIST} replace />
  }
  if (can({ useAny: AuthUserPermission.ORG_DASHBOARD }) && !!organizations.data?.length) {
    return <Navigate to={ADMIN_ROUTES.ORGANIZATION_LIST} replace />
  }
  if (can({ useAny: AuthUserPermission.USER_DASHBOARD })) {
    return <Navigate to={ADMIN_ROUTES.USER_LIST} replace />
  }
  if (can({ useAny: AuthUserPermission.MANAGE_ENROLLMENTS })) {
    return <Navigate to={ADMIN_ROUTES.ENROLLMENTS_LIST} replace />
  }
  if (
    can({
      useAny: [AuthUserPermission.AGREEMENTS_OFFER_READ, AuthUserPermission.MANAGE_AGREEMENTS],
    })
  ) {
    return (
      <Navigate
        to={generatePath(ADMIN_ROUTES.AGREEMENT_TYPE_LIST, { type: 'data-validation' })}
        replace
      />
    )
  }

  return <Forbidden />
}
